import { ArrowDown, X } from "lucide-react";
import { TRADITIONAL_PAINS, B2L_STEPS } from "../../data/content";

export default function CoreProposition() {
  return (
    <section className="py-24 lg:py-36 border-t border-white/5" data-testid="core-proposition-section">
      <div className="container-x">
        <p className="section-label">THE PROBLEM WE KILL</p>
        <h2 className="mt-5 font-heading text-4xl sm:text-5xl font-bold tracking-tight text-white max-w-3xl">
          YOU DON'T NEED TO WAIT <span className="text-flame">MONTHS</span> FOR SOFTWARE.
        </h2>
        <p className="mt-6 text-slate-400 max-w-2xl leading-relaxed">
          Traditional software development can involve endless friction. Built2Last.live compresses the entire cycle —
          from business idea to working software.
        </p>

        <div className="mt-16 grid grid-cols-1 lg:grid-cols-2 gap-8">
          <div className="rounded-2xl border border-white/5 bg-navy-800/50 p-8 sm:p-10">
            <p className="font-mono text-[11px] tracking-[0.25em] text-slate-500 mb-8">TRADITIONAL DEVELOPMENT</p>
            <ul className="space-y-4">
              {TRADITIONAL_PAINS.map((s) => (
                <li key={s} className="flex items-center gap-4 text-slate-500">
                  <span className="w-7 h-7 rounded-full border border-white/10 flex items-center justify-center shrink-0">
                    <X className="w-3.5 h-3.5" />
                  </span>
                  <span className="text-sm line-through decoration-white/20">{s}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="rounded-2xl border border-flame/30 bg-navy-800 p-8 sm:p-10 relative overflow-hidden">
            <div className="absolute top-0 right-0 w-40 h-40 bg-flame/10 rounded-full blur-3xl" />
            <p className="font-mono text-[11px] tracking-[0.25em] text-flame mb-8">THE BUILT2LAST.LIVE PROCESS</p>
            <ul className="space-y-1">
              {B2L_STEPS.map((s, i) => (
                <li key={s}>
                  <div className="flex items-center gap-4">
                    <span className="w-7 h-7 rounded-full bg-flame/15 border border-flame/40 flex items-center justify-center shrink-0">
                      <span className="font-mono text-[10px] font-bold text-flame">{i + 1}</span>
                    </span>
                    <span className="font-heading font-bold text-sm tracking-wide text-white">{s}</span>
                  </div>
                  {i < B2L_STEPS.length - 1 && (
                    <div className="ml-[13px] py-1"><ArrowDown className="w-3.5 h-3.5 text-flame/50" /></div>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <p className="mt-14 font-heading text-2xl sm:text-3xl font-bold tracking-tight text-slate-200">
          FROM BUSINESS IDEA TO <span className="text-flame">WORKING SOFTWARE.</span>
        </p>
      </div>
    </section>
  );
}
